document.querySelectorAll('[data-product-gallery]').forEach((root) => {
  const slides = root.querySelectorAll('[data-slide]');
  const thumbs = root.querySelectorAll('[data-thumb]');
  const set = (i) => {
    slides.forEach((s) => s.toggleAttribute('data-active', Number(s.dataset.slide) === i));
    thumbs.forEach((t) => t.classList.toggle('is-active', Number(t.dataset.thumb) === i));
  };
  thumbs.forEach((t) => t.addEventListener('click', () => set(Number(t.dataset.thumb))));
});
